<template>
  <EmdFormGroup
    :label="$t('annual-revenue')"
    :state="getState($v.recipient.annual_revenue)"
    :feedbacks="feedbacks($v.recipient.annual_revenue)"
    required
  >
    <Money
      class="emd-input"
      type="text"
      @input="() => $v.recipient.annual_revenue.$touch()"
      v-model="recipient.annual_revenue"
      mask="R$ ############"
      name="founding_date"
      v-bind="money"
      :readonly="disabled"
      :disabled="disabled"
    />
  </EmdFormGroup>
</template>

<script>
import { Money } from 'v-money'
import { EmdFormGroup } from 'emerald-vue/src/components'
import { getState, feedbacks } from '@/utils/form.utils'
import { corporationUser } from '../validations'
export default {
  name: 'AnnualRevenueInput',
  components: {
    EmdFormGroup,
    Money
  },
  data: () => ({
    getState,
    feedbacks,
    annual_revenue: '',
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      precision: 2,
      masked: false
    }
  }),
  props: {
    recipient: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  validations () {
    return { recipient: corporationUser }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "annual-revenue": "Faturamento anual",
      "placeholder": "R$ 1.234,50"
    },
    "en-US": {
      "annual-revenue":  "Annual revenue",
      "placeholder": "$1,234.50"
    }
  }
</i18n>
